import { LayoutBox } from './SpacingLayout.styles';
import type { Props } from './SpacingLayout.types';

/**
 * flex div with added flex props support: column, center, gap
 * and box props support.
 *
 * `gap` is using `--spacing-xx` css variables defined in html root.
 */
export function SpacingLayout({
    gap = 'md',
    inline,
    center,
    column = true,

    minHeight,
    maxHeight,
    minWidth,
    maxWidth,
    fullWidth,

    m,
    mb,
    mt,
    ml,
    mr,

    p,
    pb,
    pt,
    pl,
    pr,
    children,
    ...rest
}: Props) {
    return (
        <LayoutBox
            $gap={gap}
            $inline={inline}
            $center={center}
            $column={column}
            $minHeight={minHeight}
            $maxHeight={maxHeight}
            $minWidth={minWidth}
            $maxWidth={maxWidth}
            $fullWidth={fullWidth}
            $m={m}
            $mb={mb}
            $mt={mt}
            $ml={ml}
            $mr={mr}
            $p={p}
            $pb={pb}
            $pt={pt}
            $pl={pl}
            $pr={pr}
            {...rest}
        >
            {children}
        </LayoutBox>
    );
}
